import React from 'react';

import {
  InfoBlock,
  InfoColumn,
  InfoTitle,
  InfoItem,
} from '@Calix-Commerce/design-system/components';

import { formatDate } from 'utils/helpers/date';

const ShippingBlock = ({ shippingData = {}, billingData = {} }) => (
  <InfoBlock>
    <InfoColumn>
      <InfoTitle>Shipping</InfoTitle>
      <InfoItem>
        <span>Address 1:</span>
        <span>{shippingData.address.address1}</span>
      </InfoItem>
      <InfoItem>
        <span>Address 2:</span>
        <span>{shippingData.address.address2}</span>
      </InfoItem>
      <InfoItem>
        <span>City:</span>
        <span>{shippingData.address.city}</span>
      </InfoItem>
      <InfoItem>
        <span>State:</span>
        <span>{shippingData.address.state}</span>
      </InfoItem>
      <InfoItem>
        <span>Country:</span>
        <span>{shippingData.address.country}</span>
      </InfoItem>
      <InfoItem spaced>
        <span>Packing Instructions:</span>
        <span>{shippingData.packingInstructions}</span>
      </InfoItem>
      <InfoItem>
        <span>Ship To Contact:</span>
        <span>{shippingData.shipToContactName}</span>
      </InfoItem>
      <InfoItem spaced>
        <span>Requested Ship Date:</span>
        <span>{formatDate(shippingData.requestedShipDate)}</span>
      </InfoItem>
      <InfoItem>
        <span>Ship Complete Date:</span>
        <span>{formatDate(shippingData.shipCompleteDate)}</span>
      </InfoItem>
    </InfoColumn>
    <InfoColumn>
      <InfoTitle>Billing</InfoTitle>
      <InfoItem>
        <span>Address 1:</span>
        <span>{billingData.address.address1}</span>
      </InfoItem>
      <InfoItem>
        <span>Address 2:</span>
        <span>{billingData.address.address2}</span>
      </InfoItem>
      <InfoItem>
        <span>City:</span>
        <span>{billingData.address.city}</span>
      </InfoItem>
      <InfoItem>
        <span>State:</span>
        <span>{billingData.address.state}</span>
      </InfoItem>
      <InfoItem>
        <span>Country:</span>
        <span>{billingData.address.country}</span>
      </InfoItem>
    </InfoColumn>
  </InfoBlock>
);

export { ShippingBlock };
